import {
	Box,
	Button,
	Flex,
	FormControl,
	FormLabel,
	Heading,
	Input,
	Text,
	Textarea,
} from "@chakra-ui/react";
import React from "react";

const SubmitPropertyForm3 = (props) => {
	const { register, errors, fields, handleAddMore, handleRemove } = props;

	return (
		<>
			<Heading w="100%" textAlign={"center"} fontWeight="normal">
				Investment Highlights
			</Heading>
			<Box as="div">
				{fields.map((item, index) => (
					<Box as="div" key={item.id} mt="5%">
						<FormControl>
							<FormLabel>Title</FormLabel>
							<Input
								{...register(`investments[${index}].investmentTitle`, {
									required: "Title is required",
								})}
								placeholder="Title"
								rounded="md"
							/>
							{errors.investments && (
								<Text color="red">
									{errors.investments[index]?.investmentTitle?.message}
								</Text>
							)}
						</FormControl>

						<FormControl mt="2%">
							<FormLabel>Description</FormLabel>
							<Textarea
								{...register(`investments[${index}].investorDescription`, {
									required: "Description is required",
								})}
								placeholder="Description"
								rows={4}
							/>
							{errors.investments && (
								<Text color="red">
									{errors.investments[index]?.investorDescription?.message}
								</Text>
							)}
						</FormControl>
						<Flex mt="3%" alignItems="center" justifyContent="space-between">
							<Button onClick={() => handleRemove(index)} color="#315B84">
								Remove
							</Button>
							{fields.length - 1 === index ? (
								<Button onClick={handleAddMore} color="#315B84">
									Add More
								</Button>
							) : null}
						</Flex>
					</Box>
				))}
			</Box>
		</>
	);
};

export default SubmitPropertyForm3;
